import {palette} from '@dentalux/ui-library-core'

const customColors = {
  primary: '#00A4D1',
  primaryLight: '#EBFBFF',
  white: '#ffffff',
  black: '#000',
  regentGray: '#7A8A9E',
  gray: '#C4C4C4',
  'grey-400': '#BDBDBD',
  'grey-500': '#9E9E9E',
  'grey-700': '#616161',
  'grey-800': '#424242',
  'grey-900': '#212121',
  'grey-600': '#757575',
  background: palette.grey['50'] || 'grey',
  backgroudSecondary: '#F9F9F9',
  mainText: '#525252',
  darkText: '#212121',
  success: '#65A50A',
  error: '#B71C1C',
  border: 'rgba(0, 0, 0, 0.42)',
  lightBorder: '#E5E5E5',
  selection: 'rgba(0, 164, 209, 0.2)',
  orange: '#ED8403',
  gainsboro: '#DCDCDC',
  heading: '#0C0C0D',
}

export default customColors
